import { TeamConfig } from "../hooks/useTeamConfig";

export function createBase64String(value?: string | number | object | null) {
  let base64 = "";
  if (!value) return base64;
  try {
    const str = encodeURIComponent(JSON.stringify(value));
    base64 = window.btoa(str).replaceAll("=", "");
  } catch (err) {
    console.log(err);
  }
  return base64;
}

export function decodeBase64String<T>(str?: string): T | null {
  let decoded = null;
  if (!str) return decoded;
  try {
    decoded = JSON.parse(decodeURIComponent(window.atob(str)));
  } catch (err) {
    console.log(err);
  }
  return decoded;
}

export function isDecodableWithAtob(inputString: string) {
  try {
    JSON.parse(window.atob(inputString));
    return true; // Decodable
  } catch (error) {
    return false; // Not decodable
  }
}
